export const ALLOCATUS_CATEGORY = 'Allocatus';

export enum CustomProperties {
  TaskId = 'TaskId',
  AppointmentId = 'AppointmentId'
}

export enum StorageItem {
  Tokens = 'Allocatus.Tokens',
  Graph = 'Allocatus.GraphToken',
  ResourceId = 'Allocatus.UserResourceId',
  Settings = 'Allocatus.Settings'
}